var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"tw-rounded-2xl tw-w-full tw-h-full tw-object-center tw-object-cover tw-aspect-[16/10] tw-max-h-44 lg:tw-max-h-72",attrs:{"src":_setup.returnMediaURL(_setup.props.src),"alt":_setup.props.alt,"loading":"lazy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }